import React from 'react';
import styled from '@emotion/styled';
import { Breadcrumbs } from '../Breadcrumb';
import Body1 from '../Typography/Body/Body1';
import Headline3 from '../Typography/Heading/Headline3';
import breakpoints from '../Theme/breakpoints';

const Container = styled.div`
  padding: 0 1rem;
  margin: auto;
  max-width: 100%;

  @media (min-width: ${breakpoints.sm}px) {
    padding: 0;
    max-width: 65ch;
  }
`;

const ButtonContainer = styled.div`
  margin-top: 2.5rem;
  text-align: center;
`;

const StyledHeadline3 = styled(Headline3)`
  margin: 1rem 0;
`;

const Section = styled.div`
  margin-bottom: 2rem;
`;

interface SubmitJobPostingsPageLayoutProperties {
  breadcrumbs: React.ReactNode[];
  title: string;
  description: string;
  bodyText: React.ReactNode;
  callToActionText: React.ReactNode;
  button: React.ReactNode;
}

const SubmitJobPostingsPageLayout = ({
  breadcrumbs,
  title,
  description,
  bodyText,
  callToActionText,
  button,
}: SubmitJobPostingsPageLayoutProperties) => (
  <Container>
    <Breadcrumbs crumbs={breadcrumbs} />
    <Section>
      <StyledHeadline3 tag="h1">{title}</StyledHeadline3>
      <Body1 tag="div">{description}</Body1>
      <ButtonContainer>{button}</ButtonContainer>
    </Section>
    <Section>
      <Body1 tag="div">{bodyText}</Body1>
      <ButtonContainer>{button}</ButtonContainer>
    </Section>
    <Section>
      <Body1 tag="div">{callToActionText}</Body1>
    </Section>
  </Container>
);

export default SubmitJobPostingsPageLayout;
